module.exports = __webpack_public_path__ + "img/icon2.26e9b43e.png";